import React, { useEffect, ReactNode } from "react";
import { usePostHog } from "posthog-js/react";

interface AnalyticsWrapperProps {
  children: ReactNode;
  product: string;
}

export const AnalyticsWrapper: React.FC<AnalyticsWrapperProps> = ({
  children,
  product,
}) => {
  const posthog = usePostHog();
  const env = import.meta.env as any;

  console.assert(!!product, "Product is required for analytics");
  console.assert(env?.VITE_APP_ENV, "VITE_APP_ENV is required for analytics");

  useEffect(() => {
    if (!posthog || !product) {
      return;
    } else {
      posthog.register({
        environment: env?.VITE_APP_ENV,
        hostname: window.location.hostname,
        product: product,
        ping_product: product,
      });
    }

    /*
    Until PostHog sees an event with your super properties (environment, hostname), they won’t show up in the UI as filterable.
    Firing a pageview event right away guarantees that those properties are attached to something immediately.
    */
    posthog.capture("$pageview");
  }, [posthog, env?.VITE_APP_ENV, product]);

  return <>{children}</>;
};
